import type { FirebaseConfig } from '@zealth/core/firebase/runtime'

const port = (value: string | undefined): number | undefined => {
  const n = Number(value)
  return value && Number.isInteger(n) && n > 0 ? n : undefined
}

/** Same shape the product apps pass to `initFirebase`; read from this package's .env. */
export const firebaseConfig: FirebaseConfig = {
  options: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  firestore: { databaseId: import.meta.env.VITE_FIRESTORE_DATABASE_ID },
  emulators: {
    enabled: import.meta.env.VITE_FIREBASE_USE_EMULATORS === 'true',
    authPort: port(import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT),
    firestorePort: port(import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT),
  },
}
